// extracted by mini-css-extract-plugin
module.exports = {"formulaAnnouncementBanner":"bw_d4","open":"bw_d5","closeIcon":"bw_d6"};